import script from "./PageTitleComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageTitleComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PageTitleComponent.vue?vue&type=style&index=0&id=75feb6b6&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75feb6b6"]])

export default __exports__